import React from "react";
import PropTypes from "prop-types";
import { Accordion, AccordionTab } from "primereact/accordion";
import { OverlayPanel } from "primereact/overlaypanel";
import { getName } from "country-list";
import SearchBar from "../searchBar/index";
import CustomeButton from "../Button/index";
import CustomCheckBox from "../CheckBox/index";

function AccessDropDown({
  refPanel,
  data,
  handleClose,
  selectedServices,
  handleSelection,
  isLoading = false,
  entityservices,
  searchEntity,
  handlSelectedService,
}) {
  return (
    <OverlayPanel ref={refPanel}>
      <div className="formgrid">
        <div className="col-12 bg-section drop-section-1">
          <SearchBar
            placeholder="Search entities by name"
            onChange={(e) => searchEntity(e.target.value)}
          />
        </div>

        <div className="col-12 mb-2 entities-panel">
          <div style={{ maxHeight: "180px", overflowY: "auto" }}>
            {data?.length > 0 ? (
              <Accordion>
                {data.map((item) => (
                  <AccordionTab
                    key={item.id}
                    header={
                      <p className="p-0 m-0">{`${item.name} (${getName(item?.country)})`}</p>
                    }
                  >
                    <div className="p-grid">
                      {item.active_services
                        .map((service) => ({
                          id: service,
                          name:
                            entityservices.find((x) => x.id === service)
                              ?.name || "",
                        }))
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map(({ id: service, name: servicename }) => {
                          const isChecked = selectedServices?.some(
                            (checkedItem) =>
                              checkedItem.entity_id === item.id &&
                              checkedItem.services.includes(service),
                          );

                          return (
                            <div
                              key={service}
                              className="p-field-checkbox pt-2 pb-2"
                            >
                              <CustomCheckBox
                                inputId={`checkbox-${service}`}
                                checked={isChecked || false}
                                onChange={(e) =>
                                  handlSelectedService(
                                    e.target.checked,
                                    item.id,
                                    service,
                                  )
                                }
                              />
                              <label
                                className="ml-2"
                                htmlFor={`checkbox-${service}`}
                              >
                                {servicename}
                              </label>
                            </div>
                          );
                        })}
                      {/* {item.active_services.map((service) => {
                        const isChecked = selectedServices?.some(
                          (checkedItem) =>
                            checkedItem.entity_id === item.id &&
                            checkedItem.services.includes(service)
                        );
                        const servicename = entityservices.find(
                          (x) => x.id === service
                        )?.name;

                        return (
                          <div
                            key={service}
                            className="p-field-checkbox pt-2 pb-2"
                          >
                            <CustomCheckBox
                              inputId={`checkbox-${service}`}
                              checked={isChecked || false}
                              onChange={(e) =>
                                handlSelectedService(
                                  e.target.checked,
                                  item.id,
                                  service
                                )
                              }
                            />
                            <label
                              className="ml-2"
                              htmlFor={`checkbox-${service}`}
                            >
                              {servicename}
                            </label>
                          </div>
                        );
                      })} */}
                    </div>
                  </AccordionTab>
                ))}
              </Accordion>
            ) : (
              <p>No items found</p>
            )}
          </div>
        </div>

        <div className="col-12 bg-section drop-section-3">
          <div className="flex justify-content-end mt-3">
            <CustomeButton
              label="Cancel"
              variant="outlined"
              className="mr-2"
              onClick={handleClose}
            />
            <CustomeButton
              label={!isLoading && "Add Selection"}
              variant="contained"
              className="access-btn"
              onClick={handleSelection}
              disabled={isLoading || !selectedServices?.length > 0}
              loading={isLoading}
            />
          </div>
        </div>
      </div>
    </OverlayPanel>
  );
}

AccessDropDown.propTypes = {
  refPanel: PropTypes.ref,
  data: PropTypes.array,
  handleClose: PropTypes.func,
  selectedServices: PropTypes.array,
  handleSelection: PropTypes.func,
  isLoading: PropTypes.bool,
  entityservices: PropTypes.array,
  searchEntity: PropTypes.func,
  handlSelectedService: PropTypes.func,
};
export default AccessDropDown;
